import React from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconButton from "components/library/IconButton";

import styles from "./SearchIcon.css";

class SearchIcon extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this._handleClick.bind(this);
  }

  _handleClick() {
    this.props.onClick();

    if (
      this.props.isActive &&
      this.props.location.pathname.includes("search")
    ) {
      this.props.history.goBack(); // TODO: handle on load in new tab and refresh
    }
  }

  render() {
    const gtmClassName = this.props.isActive
      ? "gtm-close-search"
      : "gtm-search-button";

    return (
      <IconButton
        className={classNames(styles.root, gtmClassName, {
          [styles.focused]: this.props.isFocused,
        })}
        name="search"
        onClick={this.handleClick}
      />
    );
  }
}

SearchIcon.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isFocused: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }),
};

export default withRouter(SearchIcon);
